
export const environment = {
  production: false,
  URL_WEB: 'https://testsitio.sorteoanahuac.mx',
  URL_API_LEGALES: 'https://testserviciossitioapp.sorteoanahuac.mx',
  URL_MICROSITIO: 'https://testpago.sorteoanahuac.mx/',
  URL_API_MAGNO: 'https://testserviciosapp.sorteoanahuac.mx',
  URL_MICROSITIO_ANIV: 'https://testpagoaniv.sorteoanahuac.mx',
  URL_API_ANIV: '',
  ts: 'TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA',
 
  //TDBHNjNuczNDdVIxVDNUQCNLM05CVFIqMjI0JTUzYzgzVA==
  //GCSaTPT6rUlfbDAriV5i4kIoS0w0d3oCXAh6v
};